import { render, staticRenderFns } from "./CopyObject.vue?vue&type=template&id=7d284418&"
import script from "./CopyObject.vue?vue&type=script&lang=js&"
export * from "./CopyObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports